import classes from './Box.module.css'
import ThisWeekGraphItem from './ThisWeekGraphItem'

export default function ThisWeekBox({summary}) {
    const priorities = [
        { label: 'High', key: 'High' },
        { label: 'Medium', key: 'Medium' },
        { label: 'Low', key: 'Low' }
    ];
    const priorityData = summary.tasks_this_week_by_priority;

    return (
        <div className={`${classes.item} ${classes.this_week_box}`} >
            <div className={classes.title}>Tasks This Week</div>
            {priorityData && (
                <div className={classes.content}>
                    {priorities.map(({ label, key }) => {
                        const data = priorityData[key];
                        if (!data) return null;
                        return (
                            <div className={classes.content_item} key={key}>
                                <div className={classes.content_item_title}>{label}</div>
                                <div className={classes.content_item_value}>
                                    <ThisWeekGraphItem
                                        overdue={data.overdue}
                                        due={data.due}
                                        completed={data.completed}
                                    />
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}